export const PAYMENT_FORM_TYPE = {
  eCheckPayment: 'echeck',
  cardPayment: 'card',
};

export const PAYMENT_FORM_DIFFERENT_BILLING_ADDRESS = {
  member_is_different_billing_address: { key: 'member_is_different_billing_address' },
  member_billing_address: { key: 'member_billing_address' },
  member_billing_city: { key: 'member_billing_city' },
  member_billing_country: { key: 'member_billing_country' },
  member_billing_state_or_province: { key: 'member_billing_state_or_province' },
  member_billing_zipcode: { key: 'member_billing_zipcode' },
}
